import styled from '@emotion/styled';
import { H5 } from '@/components/type';
import { SPACE } from '@/constants';

export const QuickCompareHeader = styled(H5)`
  margin-top: ${SPACE.X1};
  margin-bottom: ${SPACE.X1};
`;
